import { render, staticRenderFns } from "./my-user-details.vue?vue&type=template&id=94be9582&"
import script from "./my-user-details.vue?vue&type=script&lang=js&"
export * from "./my-user-details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports